import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaDollarSign,
  FaShoppingBag,
  FaClock,
  FaTools,
  FaHeadset,
  FaThumbsUp,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const AffordableEcommerceWebDevelopmentInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Affordable E-commerce Web Development in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Cost-Effective Online Solutions</Subheading>}
        heading={
          <Heading>
            Affordable{" "}
            <span tw="text-primary-500">E-commerce Web Development</span> in Bur
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer budget-friendly e-commerce web
            development services in **Bur Dubai**, delivering high-quality,
            scalable online stores without breaking the bank. Perfect for
            startups and small businesses looking to thrive in a competitive
            market.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Budget e-commerce on laptop
          "https://images.unsplash.com/photo-1617042375876-a13e36732a04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Budget planning with calculator
          "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Person working on budget website
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Get a Free Quote"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Affordable E-commerce Excellence in Bur Dubai"
        description="Quality meets affordability with our tailored solutions."
        cards={[
          {
            icon: <FaDollarSign color="#ff5464" size={40} />,
            title: "Budget-Friendly Pricing",
            description:
              "Competitive rates designed for small businesses and startups.",
          },
          {
            icon: <FaShoppingBag color="#ff5464" size={40} />,
            title: "Essential Features",
            description:
              "Get all the core tools you need for a successful online store.",
          },
          {
            icon: <FaClock color="#ff5464" size={40} />,
            title: "Quick Turnaround",
            description: "Fast delivery without compromising on quality.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Scalable Designs",
            description: "Start small and grow with cost-effective upgrades.",
          },
          {
            icon: <FaHeadset color="#ff5464" size={40} />,
            title: "Dedicated Support",
            description: "Affordable plans with ongoing assistance included.",
          },
          {
            icon: <FaThumbsUp color="#ff5464" size={40} />,
            title: "Trusted Quality",
            description: "High standards at prices that fit your budget.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Cost-Effective Process for E-commerce Development"
        description={
          <Description>
            We keep costs low and quality high with an efficient process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Free initial discussion to align with your budget.
              </li>
              <li>Planning: Strategize a lean, effective design plan.</li>
              <li>Development: Build using proven, affordable technologies.</li>
              <li>Customization: Add only what you need to keep costs down.</li>
              <li>
                Testing: Ensure functionality within your budget constraints.
              </li>
              <li>
                Launch & Support: Affordable maintenance to keep you running.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Cost-effective planning
          "https://images.unsplash.com/photo-1472289065668-ce650ac443d2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Small business in Dubai
          "https://images.unsplash.com/photo-1577401239170-897942555fb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Budget e-commerce shopping
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Affordable Wins in Bur Dubai"
        description="Our affordable solutions deliver real results for local businesses."
        cards={[
          {
            icon: <FaDollarSign color="#ff5464" size={40} />,
            title: "Cost Savings",
            description:
              "Saved a startup 40% on their e-commerce launch budget.",
          },
          {
            icon: <FaShoppingBag color="#ff5464" size={40} />,
            title: "Sales Growth",
            description:
              "Doubled online sales for a small retailer in 3 months.",
          },
          {
            icon: <FaThumbsUp color="#ff5464" size={40} />,
            title: "Client Happiness",
            description: "100% satisfaction from budget-conscious clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Start Selling Online?</Subheading>}
        heading="Affordable E-commerce Solutions in Bur Dubai"
        description={
          <Description>
            Launch your online store with MilaajBrandset’s cost-effective
            e-commerce web development services in Bur Dubai. Quality doesn’t
            have to come with a high price tag—let’s get started today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Small business team meeting
          "https://images.unsplash.com/photo-1537476102677-80bac0ab1d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Dubai marketplace
          "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Budget handshake deal
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
